import { FC, useEffect, useState } from 'react'
import s from './index.module.less'
import { Modal } from 'antd'
interface Props {
  visible: boolean
  discountNum: number
}
const UpgradeModal: FC<Props> = (props) => {
  const { visible, discountNum } = props
  const [open, setOpen] = useState(false)
  useEffect(() => { setOpen(visible) }, [visible])
  const closeModal = () => setOpen(false)
  
  return (
    <Modal wrapClassName={s.modal} open={open} onCancel={closeModal} 
    centered destroyOnClose={true} closable={false} 
    footer={null} mask={false} maskClosable={true}>
      <div className={s.root}>
        <div className='closeBtn' onClick={closeModal}>
          <i className='iconfont icon-lujing3'></i>
        </div>
        <div className='discount'>{discountNum}元<span>，</span></div>
        <div className="footer">
            <div className='btn' onClick={closeModal}>我已知晓</div>
        </div>
      </div>
    </Modal>
  )
}
export default UpgradeModal
